
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiRevolverReviewCarousel from './vendors/farlo-ui-revolver-review-carousel.js';

// Import Footer Components
import { cookieCompliance } from './components/footer/cookieCompliance.js';
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { faqs } from './components/footer/faqs';
import { navicon } from './components/footer/navicon.js';
import { navigation } from './components/footer/navigation.js';
import { smoothScroll } from './components/footer/smoothScroll.js';
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { setHeaderHeight, handleResize } from './components/footer/setHeaderHeight.js';
import { toggleFAQ } from './components/footer/toggleActiveClass.js';
import { addScrolledMastheadClass } from './components/footer/addScrolledMasthead.js';
import { updateHeaderHeightVariables } from "./components/footer/updateHeaderHeightVars.js";
import { setSignupHeight } from './components/footer/setSignupHeight.js';
import { headingSpan } from './components/footer/headingSpan.js';
import { logoHiding } from './components/footer/logoHiding.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { gsapMarquee } from './components/footer/gsapMarquee.js';
import { flipper } from './components/footer/flipper.js';


((document, window, history) => {
	const pushState = history.pushState;


	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	function ticketCalendar() {

	}

	document.addEventListener('DOMContentLoaded', () => {


		updateHeaderHeightVariables();
		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			ticketCalendar();
		}
		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar();
			});
		}
	});

	document.addEventListener('DOMContentLoaded', () => {

		if(document.querySelectorAll('h1', '.is-style-heading-1')){
			headingSpan();
		} 

		if(document.querySelector('.flipper-title')){
			flipper();
		}


		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}
	
		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelectorAll('.wp-block-embed')) { 
			embedOverlay();
		}

		if (document.querySelector('.site-logo')){
			logoHiding();
		}

		if (document.querySelector('.site-main')){
			addScrolledClass();
		}

		if (document.querySelector('.sign-up-area')){
			window.addEventListener('resize', setSignupHeight);
			setSignupHeight();
		}

		if (document.querySelector('.masthead')){
			addScrolledMastheadClass();
		}

		if (document.querySelector('.farlo-ui-map')){
			mapLoader();
		}

		document.querySelectorAll('.site-marquee__scroll-text').forEach((_sel) => {
			gsapMarquee(_sel);
		});

		if (document.querySelector('.site-header')){
			setHeaderHeight();
			
			window.addEventListener('resize', handleResize);
		}
	
		if (document.querySelector('.farlo-ui-crm--inline')) {
			
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}
	
		if (document.querySelector('.farlo-ui-crm__toggle')) {
			document.querySelectorAll('.farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.rank-math-list-item')){
			document.querySelectorAll(".rank-math-question").forEach((_el) => {
                _el.dataset.toggled = "0";
                _el.addEventListener("click", () => {
                    toggleFAQ(_el);
                })
            });
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}



		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="review-carousel"]').forEach((_sel) => {
				new FarloUiRevolverReviewCarousel(_sel);
			});
		}




		
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
